import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AppVersionPanelComponent } from "@contexts/jovdk-web";

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [
        CommonModule,
        RouterOutlet,
        TranslateModule,
        AppVersionPanelComponent
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.css'
})
export class AppComponent implements OnInit
{
    logoError = false;

    constructor(public readonly translate: TranslateService)
    {
    }

    ngOnInit(): void
    {
        this.translate.setDefaultLang('en');
        const browserLang = navigator.language ? navigator.language.split('-')[0] : 'en';
        const savedLang = localStorage.getItem('language');
        const initialLang = savedLang ? savedLang : ((browserLang === 'pt' || browserLang === 'es') ? browserLang : 'en');
        this.translate.use(initialLang);
        localStorage.setItem('language', initialLang);
    }

    onLogoError(event: Event): void
    {
        this.logoError = true;
        (event.target as HTMLImageElement).style.display = 'none';
    }

    onLanguageChange(event: Event): void
    {
        const newLang = (event.target as HTMLSelectElement).value;
        this.translate.use(newLang);
        localStorage.setItem('language', newLang);
    }
}
